import React from "react";
import styles from "./RequestErrorModal.module.css";

import {
  NewModal,
  NewModalContent,
  NewModalFooter,
  NewModalBody,
  NewModalHeader,
  NewModalRef,
  NewModalTitle,
  NewModalCloseButton,
} from "../NewModal/NewModal";

import icon from "../../../assets/contact/cpfCnpj-alert.png";
import ButtonComponent from "../../ButtonComponent";

const RequestErrorModal = React.forwardRef<NewModalRef>((props, ref) => {
  return (
    <NewModal ref={ref}>
      <NewModalContent>
        <NewModalHeader>
          <img width="40px" height="40px" src={icon} alt="" />
          <NewModalTitle>Oops... algo deu errado</NewModalTitle>
        </NewModalHeader>

        <NewModalBody>
          <p className={styles.textSize}>
            Ocorreu um erro ao tentar realizar a operação. Por favor, tente
            novamente.
          </p>
        </NewModalBody>

        <NewModalFooter>
          <NewModalCloseButton>
            <ButtonComponent className={`continue-button ${styles.buttonSize}`}>
              Tentar novamente
            </ButtonComponent>
          </NewModalCloseButton>
        </NewModalFooter>
      </NewModalContent>
    </NewModal>
  );
});

export default RequestErrorModal;
